// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Control } from '../Control';
import HotkeysSettingsGroupTemplate from '@front/templates/HotkeysSettingsGroupTemplate.html';
export class HotkeysSettingsGroup extends Control {
    constructor() {
        super();
    }
    oncomplete() {
        super.oncomplete();
        this.on('clickHeader', this.changeStateCollapse);
        this.observe('groupItem', this.createGroupController);
    }
    createGroupController(value) {
        if (isNullOrUndefined(value)) {
            return;
        }
        void this.set({ groupName: value.GroupName, groupItems: value.GroupItems });
    }
    changeStateCollapse() {
        const isOpen = this.get('isOpen');
        void this.set({ isOpen: !isOpen });
    }
}
Control.extendWith(HotkeysSettingsGroup, {
    template: HotkeysSettingsGroupTemplate,
    data: function () {
        return {
            groupName: '',
            groupItems: null,
            isOpen: true
        };
    }
});
